import { z } from 'zod';

import { schemaMailTemplate } from './schemaMailTemplate';
import { schemaMailSignatureTemplate } from './schemaSignatureTemplate';
import { schemaSystemMailTemplate } from './schemaSystemMailTemplate';

export const schemaTemplate = z.discriminatedUnion('type', [
    schemaMailTemplate,
    schemaSystemMailTemplate,
    schemaMailSignatureTemplate,
]);

export type SchemaTemplate = z.infer<typeof schemaTemplate>;
